import type { ActionBinding } from "../ActionBinding.type"
import { InputProfilePresetId } from "../InputProfilePreset/InputProfilePresetId.enum"
import type { InputProfile } from "./InputProfile.type"
import { getInputProfilePreset } from "./getInputProfilePreset"

export function createDefaultInputProfile(id: number): InputProfile {
  // Merge ClassicKeyboard and DefaultGamepad presets as per requirements
  const classicBindings = getInputProfilePreset(InputProfilePresetId.ClassicKeyboard)
  const gamepadBindings = getInputProfilePreset(InputProfilePresetId.DefaultGamepad)
  
  // Combine bindings (gamepad bindings may override keyboard bindings for same actions)
  const actionBindings: ActionBinding[] = [...classicBindings, ...gamepadBindings]
  
  return {
    id,
    dname: 'Default Controls',
    updated_at: Date.now(),
    actionBindings,
  }
}